import Button from 'components/Button/Button';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  deleteLine,
  getDrawingToolControlData,
  getSelectedLine,
  setSelectedLine,
  updateLine,
} from 'store/lixaniPaint/slices/drawingToolSlice';

export const LineSettings = () => {
  const dispatch = useDispatch();
  const controlData = useSelector(getDrawingToolControlData);
  const selectedLine = useSelector(getSelectedLine);

  const handleLineColorChange = (e) => {
    if (!selectedLine) return;
    dispatch(setSelectedLine({ ...selectedLine, lineColor: e.target.value }));
    dispatch(updateLine({ ...selectedLine, lineColor: e.target.value }));
  };

  const handleLineWidthChange = (e) => {
    if (!selectedLine) return;
    dispatch(
      setSelectedLine({ ...selectedLine, lineWidth: parseInt(e.target.value) })
    );
    dispatch(
      updateLine({ ...selectedLine, lineWidth: parseInt(e.target.value) })
    );
  };

  const handleDeleteLine = () => {
    if (selectedLine) {
      dispatch(deleteLine({ id: selectedLine.id }));
      dispatch(setSelectedLine(null));
    }
  };
  return (
    <div style={{ padding: '16px', color: 'white' }}>
      <div style={{ marginBottom: '16px' }}>
        <label
          style={{
            display: 'block',
            marginBottom: '8px',
            fontSize: '14px',
            fontWeight: '500',
          }}
        >
          Viivan väri
        </label>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <input
            type="color"
            value={selectedLine?.lineColor || controlData.lineColor}
            onChange={handleLineColorChange}
            style={{
              width: '40px',
              height: '32px',
              border: '1px solid rgba(255,255,255,0.3)',
              borderRadius: '6px',
              backgroundColor: 'transparent',
              cursor: 'pointer',
            }}
          />
          <span style={{ fontSize: '13px', opacity: 0.8 }}>
            {selectedLine?.lineColor || controlData.lineColor}
          </span>
        </div>
      </div>

      <div style={{ marginBottom: '16px' }}>
        <label
          style={{
            display: 'block',
            marginBottom: '8px',
            fontSize: '14px',
            fontWeight: '500',
          }}
        >
          Viivan leveys
        </label>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <input
            type="range"
            min="1"
            max="10"
            value={selectedLine?.lineWidth || controlData.lineWidth}
            onChange={handleLineWidthChange}
            style={{
              flex: 1,
              height: '6px',
              borderRadius: '3px',
              background: 'rgba(255,255,255,0.2)',
              outline: 'none',
              cursor: 'pointer',
            }}
          />
          <span
            style={{
              minWidth: '40px',
              fontSize: '13px',
              fontWeight: '500',
              padding: '4px 8px',
              backgroundColor: 'rgba(255,255,255,0.1)',
              borderRadius: '4px',
              textAlign: 'center',
            }}
          >
            {selectedLine?.lineWidth || controlData.lineWidth}px
          </span>
        </div>
      </div>

      {selectedLine && (
        <Button
          onClick={handleDeleteLine}
          color="danger"
          fullWidth
          size="small"
          style={{ marginTop: '8px' }}
        >
          Poista viiva
        </Button>
      )}
    </div>
  );
};
